import { render, staticRenderFns } from "./professor-curso.vue?vue&type=template&id=457dace4&"
import script from "./professor-curso.vue?vue&type=script&lang=js&"
export * from "./professor-curso.vue?vue&type=script&lang=js&"
import style0 from "./professor-curso.vue?vue&type=style&index=0&id=457dace4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports